var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftElips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 991,
    viewBox: "0 0 576 991",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2488_607)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 120,
    rx: 100,
    ry: 120,
    transform: "matrix(0.999994 -0.00350824 0.00152035 0.999999 0 375.702)",
    fill: "#E30B5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2488_607",
    x: -374.818,
    y: 0.350189,
    width: 949.999,
    height: 990.001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 187.5,
    result: "effect1_foregroundBlur_2488_607"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftElips);
export default __webpack_public_path__ + "static/media/leftElips.8ec731a3f4e798880a8288142e4db42c.svg";
export { ForwardRef as ReactComponent };